import { CheckIcon } from '@heroicons/react/24/solid';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react';
import type { FC } from 'react';

export interface GenericAlertProps {
  title: string;
  message: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  button?: { icon: any; text?: string; title: string };
}

const GenericAlert: FC<GenericAlertProps> = ({ ...props }) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={() => {
        props.setIsOpen(false);
        props.onCancel?.();
      }}
      placement='center'
      backdrop='blur'
    >
      <ModalContent>
        <ModalHeader className='flex flex-col gap-1'>{props.title}</ModalHeader>
        <ModalBody>
          <p className='text-sm text-gray-600'>{props.message}</p>
        </ModalBody>
        <ModalFooter>
          <Button
            variant='flat'
            onPress={() => {
              props.setIsOpen(false);
              props.onCancel?.();
            }}
          >
            Cancel
          </Button>
          {props.button ? (
            <Button
              color='primary'
              onPress={props.onConfirm}
              startContent={<props.button.icon className='w-5 h-5' />}
            >
              {props.button.text || 'Confirm'}
            </Button>
          ) : (
            <Button
              color='primary'
              onPress={props.onConfirm}
              startContent={<CheckIcon className='w-5 h-5' />}
            >
              Confirm
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default GenericAlert;
